"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StormCraftIncorporatedRebalanced = void 0;
var Tags_1 = require("../../Tags");
var ResourceType_1 = require("../../../ResourceType");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var Card_1 = require("../../Card");
var CardRenderer_1 = require("../../render/CardRenderer");
var CardRenderItem_1 = require("../../render/CardRenderItem");
var StormCraftIncorporatedRebalanced = (function (_super) {
    __extends(StormCraftIncorporatedRebalanced, _super);
    function StormCraftIncorporatedRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.STORMCRAFT_INCORPORATED_REBALANCED,
            tags: [Tags_1.Tags.JOVIAN],
            startingMegaCredits: 50,
            cardType: CardType_1.CardType.CORPORATION,
            initialActionText: 'Draw 1 card with a floater icon on it',
            metadata: {
                cardNumber: 'R29',
                description: 'You start with 50 M€. As your first action, reveal cards from the deck until you have revealed 1 card with a floater icon on it. Take that card into hand and discard the rest.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br.br.br;
                    b.megacredits(50).nbsp.cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.FLOATER);
                    b.corpBox('effect', function (ce) {
                        ce.effect('When you gain a floater to ANY CARD, also gain 1MC or 1 Energy.', function (eb) {
                            eb.floaters(1).asterix().startEffect.megacredits(1).slash().energy(1);
                        });
                        ce.vSpace();
                    });
                }),
            },
        }) || this;
    }
    StormCraftIncorporatedRebalanced.prototype.initialAction = function (player) {
        player.drawCard(1, {
            include: function (card) { return StormCraftIncorporatedRebalanced.floaterCards.has(card.name) || card.resourceType === ResourceType_1.ResourceType.FLOATER; },
        });
        return undefined;
    };
    StormCraftIncorporatedRebalanced.prototype.play = function () {
        return undefined;
    };
    StormCraftIncorporatedRebalanced.floaterCards = new Set([
        CardName_1.CardName.AEROSPORT_TOURNAMENT,
        CardName_1.CardName.AIR_SCRAPPING_EXPEDITION,
        CardName_1.CardName.AIR_RAID,
        CardName_1.CardName.AIRLINERS,
        CardName_1.CardName.ATMOSCOOP,
        CardName_1.CardName.FLOATER_LEASING,
        CardName_1.CardName.FLOATER_PROTOTYPES,
        CardName_1.CardName.FLOATER_TECHNOLOGY,
        CardName_1.CardName.HYDROGEN_TO_VENUS,
        CardName_1.CardName.NITROGEN_FROM_TITAN,
        CardName_1.CardName.STRATOSPHERIC_BIRDS,
    ]);
    return StormCraftIncorporatedRebalanced;
}(Card_1.Card));
exports.StormCraftIncorporatedRebalanced = StormCraftIncorporatedRebalanced;
//# sourceMappingURL=StormCraftIncorporatedRebalanced.js.map